export const IS_OWNER_COMPANIES_DATA_LOADED = 'navigation/IS_OWNER_COMPANIES_DATA_LOADED'
export const IS_CURRENT_USER_DATA_LOADED = 'navigation/IS_CURRENT_USER_DATA_LOADED'
export const CREATE_NEW_COMPANY_DIALOG = 'navigation/CREATE_NEW_COMPANY_DIALOG'
export const CREATE_NEW_COMPANY = 'navigation/CREATE_NEW_COMPANY'
export const SELECTED_COMPANY = 'navigation/SELECTED_COMPANY'
export const UPDATE_COUPONS = 'navigation/UPDATE_COUPONS'
export const GET_CAN_COMPANY_USE_COUPONS = 'navigation/GET_CAN_COMPANY_USE_COUPONS'
export const UPDATE_COMPANY_FEATURES = 'navigation/UPDATE_COMPANY_FEATURES'
